import PropTypes from 'prop-types';
import Button from 'sd-ui/dist/commonjs/components/Button/Button';
import Popover from 'sd-ui/dist/commonjs/components/Popover/Popover';
import Icon from '../../icon';

export default function ViewOnlyPopover({ articleLink }) {
  return (
    <Popover
      id="view-only-popover"
      align="right"
      className="view-only-popover branded u-show-from-sm"
      width={340}
      initiallyOpen
      renderButton={props => (
        <Button
          className="view-only-popover-button"
          icon={Icon.Info}
          iconPlacement="left"
          {...props}
        >
          View-only PDF
        </Button>
      )}
      renderChildren={() => (
        <>
          <p className="u-margin-s-ver u-text++">
            <strong>Your institution does not subscribe to this publication</strong>
          </p>

          <p className="u-margin-s-bottom">
            You are viewing a free,
            {' '}
            <strong>view-only PDF</strong>
            {' '}
            of the document.
            Some options, such as Save & Print, are disabled.
          </p>

          <p>
            Full access (with save and print options) can be purchased on the
            {' '}
            <a href={articleLink}>article page</a>
            .
          </p>
        </>
      )}
    />
  );
}

ViewOnlyPopover.propTypes = {
  articleLink: PropTypes.string.isRequired,
};
